var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityHallway = function SvgFacilityHallway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-80v-720h201l160-160 161 160h198v720H120Zm60-60h600v-600H180v600Zm55-99h492L579-438 447-264l-93-129-119 154Zm153-561h186l-93-93-93 93ZM180-140v-600 600Z"
  })));
};
export default SvgFacilityHallway;